// extracted by mini-css-extract-plugin
module.exports = {"common-page-heading":"CommonPageHeading_common-page-heading_3igtX","hinge":"CommonPageHeading_hinge_1Z-3L","fadeInBottomLeft":"CommonPageHeading_fadeInBottomLeft_15Kee"};